export { default as DefaultPage } from './DefaultPage';
export { default as ProductDetail } from './ProductDetail';
export { default as SearchProduct } from './SearchProduct';



// WEBPACK FOOTER //
// ./src/features/gkproduct/index.js